import { OverlayRef } from '@angular/cdk/overlay';
import { Component, DestroyRef, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs';

import { IconButtonComponent } from '../button';
import { IconComponent } from '../icon';
import { PopoverTheme, popoverTheme } from './popover.model';
import { PopoverService } from './popover.service';

@Component({
  selector: 'sb-popover',
  standalone: true,
  templateUrl: './popover.component.html',
  styleUrls: ['popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '[class.sb-popover]': 'true',
  },
  imports: [IconButtonComponent, IconComponent, TranslateModule],
})
export class PopoverComponent {
  @HostBinding('class.sb-popover-dark')
  get isDark() {
    return this.theme === PopoverTheme.DARK;
  }

  @Input()
  theme: popoverTheme = PopoverTheme.LIGHT;

  @Input()
  title?: string;

  @HostBinding('style.maxWidth')
  @Input()
  maxWidth = '20rem';

  @Input()
  showCloseButton = false;

  private overlayRef?: OverlayRef;

  public constructor(
    private popoverService: PopoverService,
    private destroyRef: DestroyRef,
  ) {
    this.popoverService.openedPopover$
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((ref) => (this.overlayRef = ref));
  }

  public close() {
    if (this.overlayRef) {
      this.popoverService.closePopover(this.overlayRef);
    }
  }
}
